exports.performanceDetector = function () {
  console.log("This is my first npm package");
};